import apiClient from '../../components/Okta/axiosInterceptor';

const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export const addNetPromoterScore = async (payload) => {
  const requestPayload = {
    ...payload,
    user_email: normalizeEmail(payload?.user_email),
  };

  const response = await apiClient.post(
    `${process.env.REACT_APP_DWDGPT_API}/nps/responses`,
    requestPayload,
  );
  return response?.data;
};

export const getNetPromoterScoresStatus = async (userEmail) => {
  const normalizedEmail = normalizeEmail(userEmail);
  const response = await apiClient.get(
    `${process.env.REACT_APP_DWDGPT_API}/nps/status?email=${encodeURIComponent(normalizedEmail)}`,
  );
  return response?.data;
};
